import * as React from "react";
import { ErrorPane } from "@/components/organisms/ErrorPane";
import { CentredTemplate } from "@/templates/CentredTemplate";
import { useBrandingContext } from "@/contexts/BrandingContext";

export const BugFallbackPage = () => {
  return <BugFallbackPageView />;
};

export type BugFallbackPageViewProps = object;

export const BugFallbackPageView: React.FC<BugFallbackPageViewProps> = () => {
  const { email, tel } = useBrandingContext();
  return (
    <CentredTemplate headerType={"logo"}>
      <ErrorPane
        message="Unexpected failure"
        description="Please reload the page. If the problem persists, please contact customer support."
      />
      <br />
      <b>{email}</b> or call us on <b>{tel}</b> (Monday-Friday)
    </CentredTemplate>
  );
};
